import { Animation } from "@nocios/presentation-kit";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";

const PageId = 10;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;

  const DATA_IMAGES = [
    {
      image: `${baseImageUrl}animation_1.png`,
      effect: "animate-opacity",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
    {
      image: `${baseImageUrl}animation_2.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
    {
      image: `${baseImageUrl}animation_3.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
    {
      image: `${baseImageUrl}animation_4.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
  ];

  const times = [100, 500, 500, 500, 500, 600];

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    title: "Your personal network\nassistant, ready to help anytime",
    description: `Meet your AI-powered assistant, designed to\nmake connectivity smarter and more intuitive.\nWhether you need troubleshooting, network\noptimizations, or quick settings adjustments,\njust ask, and the system will guide you.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`<ul><li>Conversational AI Support – Just like Siri or\nCopilot, interact naturally to troubleshoot issues\nor adjust settings.</li>\n<li>Step-by-Step Guidance – AI navigates users\nthrough network setup, device connections, and\noptimization tasks.</li>\n<li>Proactive Alerts – Get notified about potential\nissues before they impact your experience.</li></ul>`}
      />
    ),
    rightSideComponent: <Animation times={times} pageNumber={PageId} currentPage={currentPage} images={DATA_IMAGES} />,

    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
